<div class="app-table">
    <div class="table-container">
        <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z0" (matSortChange)="sortData($event)">
            @for (col of columns; track $index) {
                <ng-container matColumnDef="{{ col.field }}">
                    @if (col?.sort) {
                        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="{{ col.label | translate }}">
                            @if (col.field === "select") {
                                @if (col.label) {
                                    {{ col.label | translate }}
                                } @else {
                                    <mat-checkbox
                                        (click)="$event.stopPropagation()"
                                        (change)="$event ? toggleAllRows() : null"
                                        [checked]="selection.hasValue() && isAllSelected()"
                                        [indeterminate]="selection.hasValue() && !isAllSelected()"
                                        [aria-label]="checkboxLabel()"
                                    ></mat-checkbox>
                                }
                            } @else {
                                {{ col.label | translate }}
                            }
                        </th>
                    } @else {
                        <th mat-header-cell *matHeaderCellDef matTooltip="{{ col.label | translate }}">
                            @if (col.field === "select") {
                                @if (col.label) {
                                    {{ col.label | translate }}
                                } @else {
                                    <mat-checkbox
                                        (click)="$event.stopPropagation()"
                                        (change)="$event ? toggleAllRows() : null"
                                        [checked]="selection.hasValue() && isAllSelected()"
                                        [indeterminate]="selection.hasValue() && !isAllSelected()"
                                        [aria-label]="checkboxLabel()"
                                    ></mat-checkbox>
                                }
                            } @else {
                                {{ col.label | translate }}
                            }
                        </th>
                    }
                    <td mat-cell *matCellDef="let row; let i = index">
                        @if (col.field === "select") {
                            <mat-checkbox
                                (click)="$event.stopPropagation()"
                                (change)="$event ? toggleRowsSelection(row) : null"
                                [checked]="selection.isSelected(row)"
                                [aria-label]="checkboxLabel(row)"
                            >
                            </mat-checkbox>
                        }

                        @if (col.field !== "action" && col.field !== "select") {
                            @if (col?.custom) {
                                <app-custom-column
                                    [rowData]="row"
                                    [columnDetails]="col"
                                    [entity]="entity"
                                    (componentEvent)="customColumnEvent.emit($event)"
                                ></app-custom-column>
                            } @else if (col.field === "index") {
                                {{ activePageIndex * pageSize + (i + 1) }}
                            } @else if (col?.isLink) {
                                <a (click)="$event.stopPropagation(); linkClick(col.field, row)">{{ row[col.field] }}</a>
                            } @else if (col.isDate) {
                                <div matTooltip="{{ row[col.field] | date: (col?.dateFormat ? col?.dateFormat : defaultDateFormat) }} ">
                                    {{
                                        row[col.field]
                                            ? (row[col.field] | date: (col?.dateFormat ? col?.dateFormat : defaultDateFormat))
                                            : row[col.field] || "N/A"
                                    }}
                                </div>
                            } @else if (col.isNumber) {
                                <div matTooltip="{{ row[col.field] }} ">
                                    {{ row[col.field] }}
                                </div>
                            } @else if (col.isLocation) {
                                <div matTooltip="{{ row[col.field] }} ">
                                    {{ row[col.field] }}
                                </div>
                            } @else if (col.field === "shgRating") {
                                <div class="star-rating" matTooltip="{{ row[col.field] || 0 }}">
                                    @for (i of [1, 2, 3, 4, 5]; track i) {
                                        <span [class]="{ filled: i <= row[col.field] }">★</span>
                                    }
                                    <span class="rating-value">({{ row[col.field] || 0 }})</span>
                                </div>
                            } @else if (col.field === "rating") {
                                <div class="star-rating" matTooltip="{{ row[col.field] || 0 }}">
                                    @for (i of [1, 2, 3, 4, 5]; track i) {
                                        <span [class]="{ filled: i <= row[col.field] }">★</span>
                                    }
                                    <span class="rating-value">({{ row[col.field] || 0 }})</span>
                                </div>
                            } @else if (col.field === "presentDays") {
                                <div class="attendance present" matTooltip="{{ row[col.field] }}">
                                    {{ row[col.field] || 0 }}
                                </div>
                            } @else if (col.field === "absentDays") {
                                <div class="attendance absent" matTooltip="{{ row[col.field] }}">
                                    {{ row[col.field] || 0 }}
                                </div>
                            } @else {
                                <div
                                    matTooltip="{{ row[col.field] }}"
                                    [style]="
                                        isStatus(row[col.field])
                                            ? {
                                                  'background-color': getStatusBgColor(row[col.field]),
                                                  color: getStatusColor(row[col.field]),
                                                  'font-weight': '400',
                                                  'border-radius': '50px',
                                                  padding: '0.5rem 1rem',
                                                  'text-align': 'center',
                                                  display: 'inline-block',
                                                  border: '1px solid',
                                                  'border-color': getStatusColor(row[col.field]),
                                              }
                                            : {}
                                    "
                                >
                                    {{ row[col.field] }}
                                </div>
                            }
                        }
                        @if (col.field === "action") {
                            <app-custom-action
                                [selectedRow]="selectedRow"
                                [rowData]="row"
                                [columnDetails]="col"
                                [entity]="entity"
                                (actioncComponentEvent)="customActionEvent.emit($event)"
                            ></app-custom-action>
                        }
                    </td>
                </ng-container>
            }

            @if (isGroup) {
                @for (item of groupConfig; track item) {
                    <ng-container [matColumnDef]="item.matColumnDef">
                        <th mat-header-cell *matHeaderCellDef [style.text-align]="item.align" [attr.colspan]="item.colspan">
                            {{ item.name | translate }}
                        </th>
                    </ng-container>
                }
                <tr mat-header-row *matHeaderRowDef="groupMatColumnDef"></tr>
            }

            <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayColumns"></tr>

            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" [attr.colspan]="displayColumns.length">
                    <img src="../../../../../assets/images/noDataFound.svg" alt="" />
                    <h1>{{ "noRecordsFound" | translate }}</h1>
                </td>
            </tr>
        </table>
    </div>
</div>
